import { type PropsWithChildren } from 'react'
import { type RecipeVariantProps, cva } from '~/styled-system/css'

const style = cva({
  base: {
    display: 'flex',
    flexWrap: 'nowrap',
    alignItems: 'center',
    gap: '1',
    whiteSpace: 'nowrap',
    rounded: 'full',
    cursor: 'pointer',
    border: 'medium',
    px: '3',
    h: '[32px]',
  },
  variants: {
    color: {
      default: {
        fontWeight: 'normal',
        bgColor: 'white',
        color: 'gray.800',
      },
      active: {
        fontWeight: 'bold',
        borderWidth: 'thin',
        borderColor: 'button.tertiary.border',
        bgColor: 'button.tertiary.background',
        color: 'button.tertiary.text',
      },
      disabled: {
        fontWeight: 'normal',
        bgColor: 'gray.300',
        color: 'gray.500',
      },
      clear: {
        fontWeight: 'normal',
        bgColor: 'white',
        color: 'link',
        cursor: 'pointer',
      },
    },
  },
  defaultVariants: {
    color: 'default',
  },
})

type Props = {
  onClick?: (v?: any) => void
} & RecipeVariantProps<typeof style>

export function FilterChip({ onClick, children, ...variants }: PropsWithChildren<Props>) {
  const color = style(variants)
  return (
    <button type="button" onClick={onClick} disabled={color === 'disabled'} className={color}>
      {children}
    </button>
  )
}
